/**
 * One decode per URL, shared by every consumer.
 *
 * The slice viewer and the NiiVue pane can both end up asking for the same
 * output file in the same session (switching modes, or the same volume used
 * as base in one place and overlay in another); decoding a NIfTI volume is
 * not free, so the parsed result is kept keyed by URL rather than re-fetched
 * and re-parsed per mount.
 */

import { loadNiftiFile, type NiftiVolume } from "@/lib/nifti";

const cache = new Map<string, Promise<NiftiVolume>>();

export function loadVolume(url: string): Promise<NiftiVolume> {
  let entry = cache.get(url);
  if (!entry) {
    entry = fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        return res.blob();
      })
      .then((blob) => loadNiftiFile(blob));
    entry.catch(() => cache.delete(url));
    cache.set(url, entry);
  }
  return entry;
}
